module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"Description","quantity":"Quantity","price":"Price","total":"Total"},"de":{"description":"Beschreibung","quantity":"Menge","price":"Preis","total":"Gesamtpreis"}}')
  delete Component.options._Ctor
}
